<h1 mat-dialog-title>{{data.title?data.title:'Attendi ...' | translate}}</h1>
<mat-dialog-content>
  <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>

  @if (data.contentMessage) {
    <div [innerHTML]="data.contentMessage"></div>
  }
  @if (!data.contentMessage) {
    <p>{{'Azione in corso...' | translate}}</p>
  }
</mat-dialog-content>
